<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<ground-header></ground-header>

<div
  class="body-container"
  style="background-image: url(assets/img/happy-land.png)"
>
  <mat-card appearance="outlined" class="card">
    <mat-card-content class="content">
      <div>
        <img class="logo" src="assets/img/logo.svg" alt="Ground logo" />
      </div>
      <p class="title">Ground</p>
      <p class="cta" *ngIf="(isAuthenticated$() | async) === false">
        <ng-container i18n="@@app.login.signInToContinue"
          >Sign in to continue</ng-container
        >
      </p>

      <div class="buttons">
        <button
          matButton="outlined"
          class="google-btn"
          (click)="onGoogleSignIn()"
        >
          <span class="google-btn-content">
            <img src="assets/img/web_light_rd_na.svg" alt="Google logo" />
            <span i18n="@@app.login.signInWithGoogle">Sign in with Google</span>
          </span>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
